import { InputType } from '../Enums/InputType';
import { CustomValidation } from './CustomValidation';
import { ControlLayout } from '../Enums/ControlLayout';
import { Attribute } from './Attribute';
import { Country } from '../Enums/Countries';
import { ForceDirection } from '../Enums/ForceDirection';

export class PhoneOptions {
  /**
 * Represent Name Of Form Control
 */
  Name:string
   /**
 *   Represent Css classes to Phonebox 
 */
 
ExtraClasses:string
 /**  Represent value of the label*/
  LabelValue:string
   /**  Represent Key of the label*/
   LabelKey:string
  /**  Represent value of the labelDescription show under Phonebox*/
  LabelDescription:string
  /**To set  value  to Phonebox */
  Value:any
  /**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */ 
  ShowAsterisk: boolean
  /** Ability to set  Phonebox required */
  IsRequired: boolean
 
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
   /** To allow  search in country list*/
   AllowSearch: boolean
  /** Set List of Custom Attribute to Phonebox  */
  AttributeList:Attribute[]
   /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
  */
 CustomValidation: CustomValidation[]=[]
 /** Ability to display or hide the label of Phonebox */
 HideLabel:  boolean
 /**Allow To Show Placeholder  */
EnablePlaceholder:boolean
/**Allow To Select First Country  */
SelectFirstCountry:boolean
/**Set Selected Country To Phone Box*/
SelectedCountryISO:Country
/**Allow Phone Validation */
PhoneValidation:boolean
/**Set List Of Countries As Prefered Countries*/
PreferedCountries:Country[]=[]
 /**  to set type of view  if Phonebox is Vertical or Horizontal */
 ViewType:ControlLayout=ControlLayout.Vertical

 ForceDirection: ForceDirection=ForceDirection.English

}